import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import {
    CustomerPartCollectionModel,
    getCustomerParts,
    GetCustomerPartsApiParameter,
} from "@midland-industries/Services/CustomerPartService";
import { CustomActions } from "@midland-industries/Store/CustomerPartNumberReducer";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<CustomActions>;
type HandlerType = ApiHandler<GetCustomerPartsApiParameter, CustomerPartCollectionModel, Props>;

export const DispatchBeginLoadCustomerParts: HandlerType = props => {
    props.dispatch({
        type: "Xcentium/CustomerParts/BeginLoadCustomerParts",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCustomerParts(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Xcentium/CustomerParts/FailedToLoadCustomerParts" });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadCustomerParts: HandlerType = props => {
    props.dispatch({
        type: "Xcentium/CustomerParts/CompleteLoadCustomerParts",
        parameter: props.apiParameter,
        collection: props.apiResult,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadCustomerParts,
    RequestDataFromApi,
    DispatchCompleteLoadCustomerParts,
];

const loadCustomerParts = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadCustomerParts");
export default loadCustomerParts;
